import {ROOT_MODAL} from '../actions/types';

type Modal = {
  isVisible: boolean;
  type: 'info' | null;
  params: {};
};

const INITIAL_STATE: Modal = {
  isVisible: false,
  type: null,
  params: {},
};

const ModalReducer = (
  state = INITIAL_STATE,
  action: {type: String; payload: any},
) => {
  switch (action.type) {
    case ROOT_MODAL:
      return {
        ...state,
        ...action?.payload,
      };
    default:
      return state;
  }
};

export default ModalReducer;
